module.exports = __webpack_public_path__ + "img/logobai.5d14eae5.png";